import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from '../context';
import { useMountEffect } from '../hooks';

const Main = () => {

    const navigate = useNavigate();
    const user = useAuthState().user;

    const mainRedirect = async () => {
        if (user && (user.username || user.email || user.phoneNumber)) {
            navigate('/pcd');
        } else {
            navigate('/login');
        }

    }

    useMountEffect(mainRedirect);

    return <React.Fragment />;
}

export default Main;